module.exports = __webpack_public_path__ + "static/media/GettyImages-1229380660_thumbnail.b939d01d.jpg";